export const SDK_ENDPOINT = 'sdk.fra-01.braze.eu'
export const EVENT_PLATFORM = 'web'
export const PLATFORM_MARKET_ATTRIBUTE = 'platform_market'
